// extracted by mini-css-extract-plugin
module.exports = {"variables":"'../../styles/variables.css'","_menuwidth":"800px","_widescreen":"1320px","_navy_blue":"undefined","_burgundy_dark":"undefined","Title":"Title_Title__3cQPx"};